import React, { ReactElement } from 'react';
import rightArrow from '../assets/images/arrowiosforward.svg';
import leftArrow from '../assets/images/arrowiosback.svg';
import { useNavigate } from 'react-router-dom';

interface propTypes {
    nextText: string | ReactElement;
    nextButtonAction: () => void;
    nextButtonDisabled?: boolean;
    sideEffects?: () => void;
    previous?: boolean;
}

const NavButtons = (props: propTypes) => {
    const Navigate = useNavigate();

    return (
        <div className="d-flex justify-content-evenly vw-100 my-4">
            {props.previous ? (
                <button className="btn btn-dark md-button" onClick={() => Navigate(-1)}>
                    <span className="btn-text">
                        <img style={{ height: '2rem' }} src={leftArrow} /> Previous
                    </span>
                </button>
            ) : (
                ''
            )}
            <button
                className="btn btn-dark md-button"
                onClick={props.nextButtonAction}
                disabled={props.nextButtonDisabled}>
                <span className="btn-text">
                    {props.nextText ? props.nextText : 'Next'}{' '}
                    <img style={{ height: '2rem' }} src={rightArrow} />
                </span>
            </button>
        </div>
    );
};

export default NavButtons;
